// 이음플렛폼 사업자 정보 (고지 목적 — 제휴업체/부동산 대시보드 하단 표시)
export const IEUM_BUSINESS_INFO = {
  companyName: '(주)이음플렛폼',
  representative: '이은송',
  businessNumber: '633-88-03692',
  address: '경기도 시흥시 서울대학로278번길 19-14, 배곧프라자 706호',
  supportEmail: 'desk@ieum.in',
  supportPhone: '070-7666-9413',
};

// 서비스 카테고리
export const SERVICE_CATEGORIES = {
  moving: { label: '이사', icon: 'FaTruck', color: '#F59E0B' },
  cleaning: { label: '입주청소', icon: 'FaBroom', color: '#22C55E' },
  internet_tv: { label: '인터넷TV', icon: 'FaWifi', color: '#3B82F6' },
  interior: { label: '인테리어', icon: 'FaPaintRoller', color: '#EC4899' },
  aircon: { label: '에어컨', icon: 'FaSnowflake', color: '#6366F1' },
  water_purifier: { label: '정수기', icon: 'FaGlassWater', color: '#06B6D4' },
  kiosk: { label: '키오스크', icon: 'FaDesktop', color: '#8B5CF6' },
};

// 제휴업체 가입 시 선택 카테고리 (피그마 순서)
export const PARTNER_SIGNUP_CATEGORIES = [
  { id: 'moving', label: '이사', icon: 'FaTruck' },
  { id: 'cleaning', label: '입주청소', icon: 'FaBroom' },
  { id: 'internet_tv', label: '인터넷TV', icon: 'FaWifi' },
  { id: 'interior', label: '인테리어', icon: 'FaPaintRoller' },
  { id: 'aircon', label: '에어컨', icon: 'FaSnowflake' },
  { id: 'water_purifier', label: '정수기', icon: 'FaGlassWater' },
  { id: 'kiosk', label: '키오스크', icon: 'FaDesktop' },
];

// 사용자 역할
export const USER_ROLES = {
  realtor: { label: '공인중개사', color: '#4A6CF7' },
  partner: { label: '제휴업체', color: '#22C55E' },
  staff: { label: '직원', color: '#F59E0B' },
  admin: { label: '관리자', color: '#EF4444' },
};

// 사용자 상태
export const USER_STATUS = {
  active: { label: '활성', color: '#22C55E' },
  inactive: { label: '비활성', color: '#9CA3AF' },
  suspended: { label: '정지', color: '#EF4444' },
};

// 본사 처리 상태 (hq_status)
export const HQ_STATUS = {
  unread: { label: '미확인', color: '#9CA3AF' },
  read: { label: '확인', color: '#3B82F6' },
  assigned: { label: '배정완료', color: '#8B5CF6' },
  settlement_check: { label: '정산확인', color: '#F59E0B' },
  settlement_done: { label: '정산완료', color: '#22C55E' },
  cancelled: { label: '취소', color: '#EF4444' },
  unmatched_cancelled: { label: '미매칭 취소', color: '#B91C1C' },
  hq_review_needed: { label: '본사검토', color: '#F97316' },
};

// 제휴업체 처리 상태 (partner_status)
export const PARTNER_STATUS = {
  unread: { label: '미확인', color: '#9CA3AF' },
  read: { label: '확인', color: '#3B82F6' },
  cancelled: { label: '취소', color: '#EF4444' },
  reserved: { label: '예약', color: '#8B5CF6' },
  completed: { label: '완료', color: '#22C55E' },
  pending: { label: '보류', color: '#F59E0B' },
  consulting: { label: '상담중', color: '#F97316' },
};

// 면적 구분
export const AREA_SIZES = {
  under_12: { label: '12평 이하' },
  between_12_20: { label: '12~20평' },
  over_20: { label: '20평 이상' },
};

// 이사 타입 (상품) — site_settings.movingTiers 키와 동일
export const MOVING_TYPES = [
  { value: 'normal', label: '일반이사' },
  { value: 'semi_pack', label: '반포장이사' },
  { value: 'pack', label: '포장이사' },
  { value: 'van', label: '용달이사' },
];

// 인터넷 종류
export const INTERNET_TYPES = [
  { value: 'kt', label: 'KT' },
  { value: 'skt', label: 'SKT' },
  { value: 'lguplus', label: 'LGU+' },
  { value: 'sk_broadband', label: 'SK브로드밴드' },
];

// 출금 상태
export const WITHDRAWAL_STATUS = {
  requested: { label: '신청', color: '#3B82F6' },
  approved: { label: '승인', color: '#F59E0B' },
  completed: { label: '완료', color: '#22C55E' },
  rejected: { label: '거절', color: '#EF4444' },
};

// 평가 유형
export const RATING_TYPES = {
  satisfied: { label: '만족', color: '#22C55E' },
  normal: { label: '보통', color: '#F59E0B' },
  unsatisfied: { label: '불만족', color: '#EF4444' },
};

// --- 사이드바/탭 메뉴 구성 ---

export const REALTOR_AUTO_APP_BASE_URL = 'https://ieum-auto.in/realtorauto';
export const REALTOR_AUTO_ADMIN_BASE_URL = `${REALTOR_AUTO_APP_BASE_URL}/admin`;

const realtorAutoAdminPath = (section = 'dashboard') => `/admin/realtorauto/${section}`;

export const REALTOR_AUTO_ADMIN_MENU = Object.freeze([
  { key: 'realtorauto-dashboard', label: '운영 현황', path: realtorAutoAdminPath() },
  { key: 'realtorauto-template', label: '전체 계약서 기본 템플릿 설정', path: realtorAutoAdminPath('template') },
  { key: 'realtorauto-irospdf', label: 'irospdf 첨부파일 확인', path: realtorAutoAdminPath('irospdf') },
  { key: 'realtorauto-payment-macro', label: '결제 매크로 설정', path: realtorAutoAdminPath('payment-macro') },
  { key: 'realtorauto-crawler', label: '크롤러 수집내역 확인', path: realtorAutoAdminPath('crawler') },
  { key: 'realtorauto-worker-queue', label: '워커 대기 현황 및 Q 대기 실시간 열람', path: realtorAutoAdminPath('worker-queue') },
  { key: 'realtorauto-failure-log', label: '실패log', path: realtorAutoAdminPath('failure-log') },
  { key: 'realtorauto-payments', label: 'realtorauto 결제내역', path: realtorAutoAdminPath('payments') },
]);

export const ADMIN_MAIL_MENU_CHILDREN = Object.freeze([
  { key: 'mail-compose', label: '메일발송', path: '/admin/mail/compose' },
  { key: 'mail-inbox', label: '받은편지함', path: '/admin/mail/inbox' },
  { key: 'mail-shared', label: '공용메일함', path: '/admin/mail/shared' },
  { key: 'mail-important', label: '중요메일함', path: '/admin/mail/important' },
  { key: 'mail-sent', label: '발신내역', path: '/admin/mail/sent' },
  { key: 'mail-drafts', label: '임시저장함', path: '/admin/mail/drafts' },
  { key: 'mail-archive', label: '보관함', path: '/admin/mail/archive' },
  { key: 'mail-spam', label: '스팸메일함', path: '/admin/mail/spam' },
  { key: 'mail-trash', label: '휴지통', path: '/admin/mail/trash' },
  { key: 'mail-settings', label: '설정', path: '/admin/mail/settings' },
]);

export const ADMIN_MAIL_MENU_ITEM = Object.freeze({
  key: 'mail', label: '메일', icon: 'MdEmail', children: ADMIN_MAIL_MENU_CHILDREN,
});

export const STAFF_ADMIN_MENU = Object.freeze([ADMIN_MAIL_MENU_ITEM]);

export const ADMIN_MENU = [
  ADMIN_MAIL_MENU_ITEM,
  { key: 'dashboard', label: '대시보드', icon: 'MdDashboard', path: '/admin' },
  {
    key: 'members', label: '회원관리', icon: 'MdPeople',
    children: [
      { key: 'partner-list', label: '제휴업체 목록', path: '/admin/members/partners' },
      { key: 'realtor-list', label: '공인중개사 목록', path: '/admin/members/realtors' },
      { key: 'customer-list', label: '일반회원 목록', path: '/admin/members/customers' },
    ],
  },
  {
    key: 'service', label: '서비스 요청', icon: 'MdAssignment',
    children: [
      { key: 'request-list', label: '전체 요청 목록', path: '/admin/service/requests' },
      { key: 'complaint', label: '고객 민원 관리', path: '/admin/service/complaints' },
      { key: 'attention-items', label: '이상 파트너 관리', path: '/admin/attention-items' },
    ],
  },
  {
    key: 'settlement', label: '정산 관리', icon: 'MdAccountBalance',
    children: [
      { key: 'partner-receivable', label: '제휴업체 미수 정산', path: '/admin/settlement/partner' },
      { key: 'payment-history', label: '결제내역', path: '/admin/settlement/payments' },
      { key: 'realtor-commission', label: '공인중개사 수수료', path: '/admin/settlement/commission' },
      { key: 'realtor-referral', label: '공인중개사 추천', path: '/admin/settlement/referral' },
      { key: 'withdrawal', label: '출금 관리', path: '/admin/settlement/withdrawal' },
    ],
  },
  {
    key: 'notification', label: '알림/공지', icon: 'MdNotifications',
    children: [
      { key: 'alimtalk', label: '알림 발송 내역', path: '/admin/notification/alimtalk' },
      { key: 'notice', label: '공지사항', path: '/admin/notification/notices' },
      { key: 'faq', label: 'FAQ', path: '/admin/notification/faq' },
    ],
  },
  {
    key: 'realtorauto', label: 'RealtorAuto', icon: 'MdBusinessCenter',
    children: REALTOR_AUTO_ADMIN_MENU,
  },
  {
    key: 'settings', label: '설정', icon: 'MdSettings',
    children: [
      { key: 'admin-account', label: '관리자 계정', path: '/admin/settings/accounts' },
      { key: 'system-log', label: '시스템 로그', path: '/admin/settings/logs' },
      { key: 'service-settings', label: '서비스 설정', path: '/admin/settings/service' },
      { key: 'db-pricing', label: 'DB 가격/수수료', path: '/admin/settings/pricing' },
      { key: 'formmail', label: '폼메일 설정', path: '/admin/settings/formmail' },
      { key: 'terms', label: '약관 설정', path: '/admin/settings/terms' },
      { key: 'consents', label: '동의 이력 관리', path: '/admin/settings/consents' },
      { key: 'app-update', label: '앱 업데이트', path: '/admin/settings/app-update' },
    ],
  },
];

// 제휴업체 햄버거 드로어 메뉴 (모바일 우선, 단일 레벨)
// 결제/정산 재편:
//   결제하기(본사가 보낸 청구서에 결제) + 결제내역(내가 결제한 기록)
//   미수금 관리
export const PARTNER_MENU = [
  { key: 'dashboard', label: '대시보드', icon: 'MdDashboard', path: '/partner' },
  { key: 'db', label: 'DB 구매 및 관리', icon: 'MdStorage', path: '/partner/db' },
  { key: 'payment-history', label: '결제내역', icon: 'MdReceipt', path: '/partner/payment/manage' },
  { key: 'settlement', label: '결제하기', icon: 'MdPayment', path: '/partner/settlement' },
  { key: 'complaints', label: '민원 처리', icon: 'IoChatbubbleEllipsesOutline', path: '/partner/complaints' },
  { key: 'mypage', label: '업체 정보 수정', icon: 'IoSettingsOutline', path: '/partner/mypage' },
];

export const REALTOR_TABS = [
  { key: 'home', label: '홈', icon: 'IoHome', path: '/realtor' },
  { key: 'recommend', label: '추천', icon: 'IoThumbsUp', path: '/realtor/recommend' },
  { key: 'manage', label: '관리·정산', icon: 'IoList', path: '/realtor/manage' },
  { key: 'mypage', label: 'MY', icon: 'IoPerson', path: '/realtor/mypage' },
];
